import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic";
import BetterBox from "../../components/BetterBox";
import BetterAlerts from "../../components/BetterAlerts";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import { forgot } from "../../crud/auth.crud";
import { TextField } from "@material-ui/core";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import { executeRecaptcha, cleanupRecaptcha } from "../../utils/useRecaptcha";

class ForgotPassword extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      loading: false,
      isLoading: false,
    };
  }

  componentWillUnmount() {
    cleanupRecaptcha();
  }

  performForgot = (captchaToken) => {
    forgot(this.state.email, captchaToken)
      .then(async (res) => {
        window.scrollTo(0, 0);

        await Swal.fire({
          icon: "success",
          title: "Tudo certo!",
          text:
            res.data.message ||
            "Se o e-mail estiver cadastrado, você receberá um link de recuperação.",
          showConfirmButton: true,
        });

        window.location.href = "/auth/login";
      })
      .catch((e) => {
        const errorMessage =
          e.response?.data?.error ||
          e.response?.data?.message ||
          "Parece que houve um problema ao enviar o e-mail. Por favor, tente novamente.";
        Swal.fire("Ops!", errorMessage, "error");

        this.setState({ isLoading: false });
      });
  };

  onSubmit = async () => {
    if (!this.state.email) {
      this.setState({ errors: ["O e-mail é uma informação obrigatória."] });
      return;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)
    ) {
      this.setState({ errors: ["Você precisa informar um e-mail válido."] });
      return;
    }

    this.setState({ isLoading: true, errors: [] });

    // TODO: Reabilitar reCAPTCHA após segunda-feira
    // try {
    //   const captchaToken = await executeRecaptcha("FORGOT_PASSWORD");
    //   this.performForgot(captchaToken);
    // } catch (err) {
    //   this.setState({ isLoading: false });
    //   Swal.fire("Ops!", "Erro na verificação de segurança. Tente novamente.", "error");
    // }

    this.performForgot(null);
  };

  render() {
    return (
      <div style={{ margin: "50px 0px 50px 0px" }}>
        <div className="row" style={{ margin: "0" }}>
          <div className="col-sm-12 col-md-8 offset-md-2 col-lg-5 offset-lg-4">
            <div className="row">
              <div className="col-sm-12">
                <center>
                  <img
                    alt="Logo"
                    src={toAbsoluteUrl("/images/logo-dark.png")}
                    style={{
                      width: "250px",
                      height: "auto",
                      marginTop: "35px",
                      marginBottom: "35px",
                    }}
                  />

                  <p
                    style={{
                      padding: "10px 50px 15px 50px",
                      fontSize: "18px",
                      color: "#424242",
                      fontWeight: "500",
                    }}
                  >
                    <b>Olá!</b> Para recuperar seu acesso, por favor informe um
                    e-mail.
                  </p>
                </center>
              </div>

              <div className="col-sm-12">
                <BetterCircularProgress loading={this.state.loading}>
                  <div>
                    <div className="col-sm-12">
                      <BetterAlerts errors={this.state.errors} />
                    </div>

                    <div>
                      <div className="col-sm-12">
                        <BetterBox
                          title="Digite um e-mail."
                          subtitle="Se o e-mail existir no sistema será enviado um link de redefinição de senha."
                        >
                          <div className="col-sm-12">
                            <div className="form-group fg-line">
                              <TextField
                                type="email"
                                name="email"
                                label="E-mail *"
                                margin="normal"
                                variant="outlined"
                                onBlur={(event) =>
                                  this.setState({ email: event.target.value })
                                }
                                onChange={(event) =>
                                  this.setState({ email: event.target.value })
                                }
                              />
                            </div>
                          </div>
                        </BetterBox>
                      </div>

                      <div className="col-sm-12">
                        <center>
                          <br />
                          <Button
                            className="btn btn-primary btn-lg btn-bold"
                            onClick={() => this.onSubmit()}
                            disabled={this.state.isLoading}
                          >
                            <i
                              className={`margin-icon ${
                                this.state.isLoading
                                  ? "fas fa-sync fa-spin"
                                  : "fa fa-check-square"
                              }`}
                            ></i>
                            Enviar
                          </Button>

                          <br />
                          <br />

                          <Link
                            to="/auth/login"
                            className="btn btn-label btn-lg btn-bold"
                          >
                            Voltar
                          </Link>
                        </center>
                      </div>
                    </div>
                  </div>
                </BetterCircularProgress>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(ForgotPassword);
